<script setup lang="ts">
import { license, openUpgrade } from '../lib/license'
</script>

<template>
  <button
    class="lic"
    :class="{ upgrade: license.needsUpgrade, trial: license.isTrial }"
    :title="license.needsUpgrade ? 'Upgrade for commercial use' : license.label + ' — manage subscription'"
    @click="openUpgrade"
  >
    {{ license.needsUpgrade ? 'Upgrade' : license.label }}
  </button>
</template>

<style scoped>
.lic {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: var(--bg);
  color: var(--muted);
  white-space: nowrap;
}
.lic.trial {
  border-color: #c97b30;
  color: #c97b30;
}
.lic.upgrade {
  background: var(--brand);
  border-color: var(--brand);
  color: #fff;
  font-weight: 600;
}
.lic.upgrade:hover {
  background: var(--brand-dark);
}
</style>
